<div fxLayout="row">
    <div fxLayout="column">
        <menu-vertical></menu-vertical>
    </div>
    <div class="dashboardContainer">
        <router-outlet></router-outlet>
    </div>
</div>